import MuiChip from '@mui/material/Chip';
import { ChipProps } from './Chip.props';

export const Chip = ({ ...props }: ChipProps) => {
  return <MuiChip {...props} />;
};

export default Chip;
